<script setup>
import { l } from '@utils/toolbox';
</script>
<template>
  <div class="chat-capacity-state">
    <div class="capacity-card">
      <h2>{{ l('chat.disabled.title') }}</h2>
      <p>{{ l('chat.disabled.description') }}</p>
      <p>{{ l('chat.disabled.retry') }}</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.chat-capacity-state {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: $container-bg;
}

.capacity-card {
  max-width: 48rem;
  padding: 3rem;
  text-align: center;
  background: $white;
  border-radius: $borderRadius-md;
  box-shadow: $lighterBoxShadow;
}

.capacity-card h2 {
  margin: 0 0 1rem;
  color: $neutral-main-font-color;
  font-size: 2rem;
}

.capacity-card p {
  margin: 0.5rem 0;
  color: $neutral-main-font-color;
  font-size: 1.5rem;
}
</style>
